import React, { type ReactNode } from 'react';

import { useIntl } from 'react-intl-next';

import { Flex, Pressable, xcss } from '@atlaskit/primitives';

import { messages } from './messages';
import { WarningIllustration } from './warning-illustration';

const buttonStyles = xcss({
	background: 'none',
	border: 'none',
	display: 'inline',
	color: 'color.link',
	cursor: 'pointer',
	padding: 'space.0',
	margin: 'space.0',
});

const wrapperStyles = xcss({
	height: '100%',
	paddingInline: 'space.400',
});

type ChatGenericErrorProps = {
	errorType: 'generic' | 'rate-limited';
};

export const ChatGenericError = ({ errorType }: ChatGenericErrorProps) => {
	const { formatMessage } = useIntl();
	const title = errorType === 'rate-limited' ? messages.rateLimitedTitle : messages.title;
	const description =
		errorType === 'rate-limited' ? messages.rateLimitedDescription : messages.description;

	return (
		<Flex
			columnGap="space.100"
			alignItems="center"
			justifyContent="center"
			direction="column"
			xcss={wrapperStyles}
			testId="ai-mate-generic-error"
		>
			<WarningIllustration />
			<>
				<h3>{formatMessage(title)}</h3>
				<p>
					{formatMessage(description, {
						btn: (chunks: ReactNode[]) => (
							<Pressable
								xcss={buttonStyles}
								onClick={() => {
									window.location.reload();
								}}
							>
								{chunks}
							</Pressable>
						),
					})}
				</p>
			</>
		</Flex>
	);
};
